__turbopack_context__.v({
  "xchain-circle-bot": "styles-module__8cyeqG__xchain-circle-bot",
  "xchain-circle-top": "styles-module__8cyeqG__xchain-circle-top",
  "xchain-connector-line-1": "styles-module__8cyeqG__xchain-connector-line-1",
  "xchainAnimationDelayed": "styles-module__8cyeqG__xchainAnimationDelayed",
  "xchainCircleBotRotation": "styles-module__8cyeqG__xchainCircleBotRotation",
  "xchainCircleOpacity": "styles-module__8cyeqG__xchainCircleOpacity",
  "xchainCircleTopRotation": "styles-module__8cyeqG__xchainCircleTopRotation",
  "xchainConnectorLine": "styles-module__8cyeqG__xchainConnectorLine",
});
